import type { HouseholderQuote, Quote } from "@/api_client";

export const quoteIndicatesUserMoving = (quotes: (Quote | undefined)[]) => {
  let hasEncounteredFalseValue = false;
  for (const quote of quotes) {
    const isHouseholderAndInsuredWithIf =
      quoteIsHouseholderAndCurrentlyInsuredWithIf(quote);
    if (isHouseholderAndInsuredWithIf) {
      return true;
    } else if (isHouseholderAndInsuredWithIf === false) {
      hasEncounteredFalseValue = true;
    }
  }
  if (hasEncounteredFalseValue) {
    return false;
  }
  return undefined;
};

const quoteIsHouseholderAndCurrentlyInsuredWithIf = (
  quote: Quote | undefined,
) => {
  if (!quote || quote.productType !== "householder") {
    return undefined;
  }
  const householderQuote = quote as HouseholderQuote;
  if (householderQuote.householder.householderInsuredWithIf === null)
    return undefined;

  return householderQuote.householder.householderInsuredWithIf;
};
